import React from 'react';
import { Tag } from '@chakra-ui/react';

export const CodeStatuses = {
  Applied: 'applied',
  Suggested: 'suggested',
  Waived: 'waived',
  RemovalSuggested: 'removal-suggested',
  Inquiring: 'inquiring',
  Removed: 'removed',
  Default: 'default'
};

export const CodeActions = {
  Apply: 'apply',
  Reject: 'reject',
  Suggest: 'suggest',
  SuggestRemoval: 'suggest-removal',
  Waive: 'waive',
  Inquire: 'inquire',
  Clear: 'clear',
  Remove: 'remove'
};

export const BulkCodeActions = {
  Unwaive: 'unwaive',
  Uninquire: 'uninquire'
};

export const CodeActionToStatus = {
  [CodeActions.Apply]: CodeStatuses.Applied,
  [CodeActions.Suggest]: CodeStatuses.Suggested,
  [CodeActions.Waive]: CodeStatuses.Waived,
  [CodeActions.Clear]: CodeStatuses.Default,
  [CodeActions.Inquire]: CodeStatuses.Inquiring,
  [CodeActions.SuggestRemoval]: CodeStatuses.RemovalSuggested,
  [BulkCodeActions.Unwaive]: BulkCodeActions.Unwaive,
  [BulkCodeActions.Uninquire]: BulkCodeActions.Uninquire,
  [CodeActions.Remove]: CodeStatuses.Removed
};

export const CodeTags = {
  [CodeStatuses.Applied]: codeLetter => (
    <Tag bgColor="transparent" color="primaryScale.600" fontWeight="semibold" px={0}>
      {codeLetter}
    </Tag>
  ),
  [CodeStatuses.Suggested]: codeLetter => (
    <Tag bgColor="transparent" color="greyScale.800" fontWeight="light" px={0}>
      {`+${codeLetter}`}
    </Tag>
  ),
  [CodeStatuses.RemovalSuggested]: codeLetter => (
    <Tag bgColor="transparent" color="greyScale.800" fontWeight="light" px={0}>
      {`-${codeLetter}`}
    </Tag>
  ),
  [CodeStatuses.Waived]: codeLetter => (
    <Tag bgColor="transparent" color="greyScale.400" fontStyle="italic" px={0}>
      {codeLetter}
    </Tag>
  ),
  [CodeStatuses.Inquiring]: codeLetter => (
    <Tag bgColor="transparent" color="black" fontWeight="semibold" px={0}>
      {`${codeLetter}*`}
    </Tag>
  )
};
